{
  "title": "Dragon's Breath",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "2nd-level transmutation",
  "level": 2,
  "castingTime": "1 bonus action",
  "range": "Touch",
  "components": "V, S, M (a hot pepper)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You touch one willing creature and imbue it with the power to spew magical energy from its mouth, provided it has one. Choose acid, cold, fire, lightning, or poison. Until the spell ends, the creature can use an action to exhale energy of the chosen type in a 15-foot cone. Each creature in that area must make a Dexterity saving throw, taking 3d6 damage of the chosen type on a failed save, or half as much damage on a successful one.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the damage increases by 1d6 for each slot level above 2nd."
  ],
  "spellLists": ["sorcerer", "wizard"]
}
